<template>
  <modal name="confirm-modal"
         :height="`auto`"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :reset="true"
         :clickToClose="false"
         @before-open="beforeOpen"
  >
    <div
        :name="modalInfo.name || ''"
        class="FloatMenu md_overlay md_overlay_0"
    >
      <div class="modal modal_0">
        <div class="md_content md_type3">
          <img
              src="/images/ic/comm/ic-problem.svg"
              class="warning_icon"
              alt=""
          />
          <div class="popup_title">
            {{ $t(`${modalInfo.header}`) }}
          </div>
          <span
              v-if="modalInfo.close"
              class="md_close"
          >
            <img
                @click="modalClose"
                src="/images/union.svg"
                alt=""
            />
          </span>
          <div
              v-if="modalInfo.description"
              class="title_desc"
          >
            {{ $t(`${modalInfo.description}`) }}
          </div>
          <LoadingOverlay :activeSyncProps="modalInfo.activeSync" :isFullPageProps="true"/>
          <component
              v-if="template"
              :is="template"
              :modalInfoProps="modalInfo"
          />
          <a
              @click="modalInfo.confirmFunction.func"
              class="btn blue btn_basics"
          >
            {{ $t(`${modalInfo.confirmFunction.button}`) }}
          </a>
          <a
              v-if="modalInfo.subFunction"
              @click="modalInfo.subFunction.func"
              class="sub_btn"
          >
            {{ $t(`${modalInfo.subFunction.button}`) }}
          </a>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import LoadingOverlay from "../../loadingOverlay";
export default {
  name: 'ConfirmModal',
  components: {LoadingOverlay},
  data() {
    return {
      template: '',
      width: 10,
      modalInfo: {
        width: 0,
        header: '',
        description: '',
        confirmFunction: {
          button: 'status.confirm',
          func: () => {
            // This is intentional
          }, params: []
        },
        subFunction: {
          button: 'status.confirm',
          func: () => {
            // This is intentional
          }, params: []
        },
        type: 'defaultTemplate',
        data: {}
      }
    }
  },
  computed: {
    loader() {
      return () => import(`@/components/modal/confirmModal/templates/${this?.modalInfo?.type || 'defaultTemplate'}`);
    }
  },
  watch: {
    modalInfo: {
      deep: true,
      handler() {
        this.template = () => this.loader()
      }
    }
  },
  mounted() {
    this.loader()
        .then(() => {
          this.template = () => this.loader()
        })
        .catch(() => {
          this.template = () => import('@/components/modal/confirmModal/templates/defaultTemplate');
        });
  },
  methods: {
    modalClose: function () {
      this.$modal.hide('confirm-modal');
    },
    beforeOpen({params}) {
      this.modalInfo = params;
    }
  }
}
</script>
<style lang="scss">

.v--modal-overlay[data-modal="confirm-modal"] {

}

.plan_container {
  display: flex;
  justify-content: center;

  .plan_item {
    padding: 16px;
    border-radius: 10px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    color: var(--grey70);
    width: 210px;

    &.after {
      border: 2px solid var(--blue70);
    }

    .unit {
      color: var(--grey100);
      font-size: 14px;
    }

    .amount {
      color: var(--grey100);
      font-size: 48px;
      font-weight: 600;
    }

    .period {
      color: var(--grey60);
      font-size: 14px;
    }

    .underline {
      border-bottom: 1px solid var(--grey20);
      margin: 12px 0;
    }

    .service_table {
      table-layout: auto;

      tr {
        th {
          font-weight: bold;
          padding: 2px 10px 2px 0;
        }

        &:hover {
          background: #fff;
        }
      }
    }
  }

  .arrow {
    display: flex;
    padding: 7px;
  }
}
</style>
